import { useEffect, useState, useCallback } from "react";
import { MailOpen } from "lucide-react";
import { api, errMsg, fmtDate } from "@/lib/api";
import { SectionTitle, Empty } from "@/admin/ui";
import { toast } from "sonner";

export function AdminContacts() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get("/admin/contacts").then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const markRead = async (c) => { try { await api.post(`/admin/contacts/${c.id}/read`); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <div>
      <SectionTitle eyebrow="Gelen Kutusu" title="İletişim Mesajları" />
      {rows === null ? <div className="h-40 rounded-2xl bg-slate-900/60 animate-pulse" /> : rows.length === 0 ? <Empty text="Henüz mesaj yok." /> : (
        <div className="space-y-3" data-testid="admin-contacts-list">
          {rows.map((c) => (
            <div key={c.id} data-testid="admin-contact-item" className={`cx-glass rounded-2xl p-5 ${!c.read ? "border-cyan-500/40" : ""}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm"><b className="text-slate-100">{c.username}</b> <span className="font-mono-cx text-xs text-slate-500">· {c.ip}</span></p>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-slate-500">{fmtDate(c.created_at)}</span>
                  {!c.read ? <button data-testid="contact-mark-read" onClick={() => markRead(c)} className="h-8 px-3 rounded-lg bg-slate-900 border border-slate-700 text-xs text-cyan-300 inline-flex items-center gap-1"><MailOpen className="h-3.5 w-3.5" /> Okundu</button> : <span className="text-[10px] font-mono-cx text-slate-600">OKUNDU</span>}
                </div>
              </div>
              <p className="text-sm text-slate-200 mt-3 whitespace-pre-wrap">{c.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
